@if (dunningTypeTriggerLogicFieldData) {
    <mvs-widget [widgetData]="dunningTypeTriggerLogicFieldData"></mvs-widget>
}
